"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _shareFilter = require("./shareFilter.styles");
var _index = require("../../index");
var _UserTag = _interopRequireDefault(require("../UserTag/UserTag"));
function ShareFilter(_ref) {
  let {
    shareFilterUsersList = [],
    isGeneratingSharableURL = false,
    sharableUrlLink = '',
    isSendingInvitation = false,
    onToggleShareFilterModal,
    onShareFilterSubmit
  } = _ref;
  const [selectedMembers, setSelectedMembers] = (0, _react.useState)([]);
  const onDropdownChange = item => {
    if (!selectedMembers.some(member => member.employeeId === item.employeeId)) {
      const alreadySelectedMembers = (0, _toConsumableArray2["default"])(selectedMembers);
      alreadySelectedMembers.push(item);
      setSelectedMembers(alreadySelectedMembers);
    }
  };
  const onRemoveTag = apmId => {
    const updateSelectedMembers = (0, _toConsumableArray2["default"])(selectedMembers);
    const findIndex = updateSelectedMembers.findIndex(user => user.employeeId === apmId);
    if (findIndex > -1) {
      updateSelectedMembers.splice(updateSelectedMembers[findIndex], 1);
      setSelectedMembers(updateSelectedMembers);
    }
  };
  const onCopyToClipBoard = () => {
    // copyToClipboard(sharableUrlLink);
    (0, _index.toastEmitter)({
      title: 'Share filter link copied!!'
    }, {
      type: 'success',
      autoClose: 1500
    });
  };
  return (0, _jsxRuntime.jsx)(_shareFilter.ConfigureModal, (0, _extends2["default"])({
    heading: "Share filter",
    open: true,
    zindex: 999999,
    showCloseIcon: true,
    dimension: "large",
    onClose: onToggleShareFilterModal,
    actions: {
      primaryAction: (0, _jsxRuntime.jsx)(_index.Button, {
        label: "Apply",
        onClick: () => onShareFilterSubmit(selectedMembers),
        loading: isSendingInvitation,
        disabled: !(selectedMembers === null || selectedMembers === void 0 ? void 0 : selectedMembers.length)
      }),
      secondaryAction: (0, _jsxRuntime.jsx)(_index.Button, {
        variant: "outlined",
        label: "Cancel",
        onClick: onToggleShareFilterModal
      })
    }
  }, {
    children: (0, _jsxRuntime.jsxs)(_index.Box, {
      children: [isGeneratingSharableURL && (0, _jsxRuntime.jsxs)(_shareFilter.LoadingComponent, {
        children: [(0, _jsxRuntime.jsx)(_shareFilter.LoadingComponentTitle, {
          children: "Generating shareable link...."
        }), (0, _jsxRuntime.jsx)(_index.LoadingIndicator, {
          variant: "spinner"
        })]
      }), sharableUrlLink && (0, _jsxRuntime.jsxs)(_shareFilter.ShareFilterBody, {
        children: [(0, _jsxRuntime.jsxs)(_shareFilter.ShareFilterUrlArea, {
          children: [(0, _jsxRuntime.jsx)(_shareFilter.ShareFilterUrlTitle, {
            children: "Link to share"
          }), (0, _jsxRuntime.jsxs)(_shareFilter.ShareFilterUrl, {
            children: [(0, _jsxRuntime.jsx)("span", {
              children: sharableUrlLink
            }), (0, _jsxRuntime.jsx)(_index.Icon, {
              name: "file-copy",
              size: "24",
              onClick: onCopyToClipBoard
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_shareFilter.ShareFilterInvite, {
          children: [(0, _jsxRuntime.jsxs)(_shareFilter.ShareFilterInviteTitle, {
            children: [(0, _jsxRuntime.jsx)("span", {
              children: "Send invite to team members"
            }), (0, _jsxRuntime.jsx)(_index.Box, {
              children: "An email invitation will be send to the user with shareable link"
            })]
          }), (0, _jsxRuntime.jsxs)(_shareFilter.InviteDropdown, {
            children: [(0, _jsxRuntime.jsx)(_index.AutoSuggest, {
              value: '',
              placeholder: "Search for APM id or email",
              id: "apmIdDropdown",
              options: shareFilterUsersList,
              suggestType: "select",
              clearButton: false,
              onSuggestionSelect: item => onDropdownChange(item)
            }), (selectedMembers === null || selectedMembers === void 0 ? void 0 : selectedMembers.length) ? (0, _jsxRuntime.jsx)(_shareFilter.UserTags, {
              children: selectedMembers.map((user, key) => (0, _jsxRuntime.jsx)(_UserTag["default"], {
                name: user.displayName,
                apmid: user.employeeId,
                onRemoveTag: onRemoveTag
              }, key))
            }) : (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})]
          })]
        })]
      })]
    })
  }));
}
var _default = exports["default"] = ShareFilter;